import React from 'react';
import {Route} from 'react-router-dom';

const replaceVars = ({to, computedMatch}) => {
  let computedTo = to;
  if (computedMatch && computedMatch.params) {
    Object.entries(computedMatch.params).forEach(([key, value]) => {
      computedTo = computedTo.replace(`:${key}`, value);
    });
  }
  return computedTo;
};

export default ({to, push, ...otherProps}) => (
  <Route
    {...otherProps}
    component={({history}) => {
      const computedTo = replaceVars({to, computedMatch: otherProps.computedMatch});

      if (push) {
        history.push(computedTo);
      } else {
        history.replace(computedTo);
      }
      return null;
    }}
  />
);
